import React from 'react';
import { FormGroup, Label } from 'reactstrap';

import { CustomSelect } from '../../../components';

const SECTORS = [
  { value: 'Kathmandu', title: 'KATHMANDU' },
  { value: 'Pokhara', title: 'POKHARA' },
  { value: 'Phedi', title: 'PHEDI' },
  { value: 'Kande', title: 'KANDE' },
  { value: 'Nayapul', title: 'NAYAPUL' },
  { value: 'Jomsom', title: 'JOMSOM' },
  { value: 'Ramechhap', title: 'RAMECHHAP' },
  { value: 'Salleri', title: 'SALLERI' },
];

export default function TransportationLocation(props: { title: string, name: string }) {
  const { title, name } = props;
  
  return (
    <FormGroup>
      <Label className="title">{title}</Label>
      <CustomSelect className="form-control" name={name} options={SECTORS} />
    </FormGroup>
  );
}


// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/TransportationLocation.js